/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Input, Select, DatePicker, InputNumber, Form, Radio } from "antd";
import FileUpload from "components/form/file-upload";
import "styles/table.css";
import { INPUT_TYPES } from "../../constants";

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
const SelectOption = Select.Option;

const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableFormRow = ({ form, index, ...props }) => {
    return (
        <EditableContext.Provider value={form}>
            <tr {...props} />
        </EditableContext.Provider>
    );
};

EditableFormRow.propTypes = {
    form: PropTypes.object,
    index: PropTypes.number,
    fieldType: PropTypes.string
};

const EditableRow = Form.create()(EditableFormRow);

class EditableCell extends React.Component {
    state = {
        editing: true
    };
    save = () => {
        const { record, handleSave, dataIndex } = this.props;
        this.form.validateFields((error, values) => {
            if (!error) {
                handleSave(record, values, dataIndex);
            }
        });
    };
    getFieldType = fieldType => {
        const baseProps = {
            onPressEnter: this.save,
            onBlur: this.save
        };
        switch (fieldType) {
        case INPUT_TYPES.DATE:
            return (
                <DatePicker
                    {...baseProps}
                    format={"DD-MM-YYYY"}
                    style={{ width: "100%" }}
                />
            );
        case INPUT_TYPES.SELECT:
            return (
                <Select {...baseProps} style={{ width: "100%" }} filterOption={true} showSearch={true} allowClear={true} dropdownMatchSelectWidth={false}>
                    {this.props.options.map(_ => (
                        <SelectOption key={_.value} value={_.value}>
                            {_.label}
                        </SelectOption>
                    ))}
                </Select>
            );
        case INPUT_TYPES.RADIO: {
            return (
                <Radio.Group onChange={baseProps.onBlur} {...baseProps} style={{ width: "100%" }}>
                    {this.props.options.map(_ => (
                        <Radio key={_.value} value={_.value}>
                            {_.label}
                        </Radio>
                    ))}
                </Radio.Group>
            );
        }
        case INPUT_TYPES.NUMBER:
            return (
                <InputNumber
                    {...baseProps}
                    max={this.props.max}
                    style={{ width: "100%" }}
                />
            );
        // case INPUT_TYPES.RADIO:
        //     return React.createElement(
        //         RadioGroup,
        //         {
        //             ...baseProps
        //         },
        //         this.props.options.map(_ =>
        //             React.createElement(
        //                 RadioButton,
        //                 {
        //                     key: _.label,
        //                     value: _.value
        //                 },
        //                 _.label
        //             )
        //         )
        //     );
        case INPUT_TYPES.FILE:
            return (
                <FileUpload
                    // onChange={this.save}
                    multiple={this.props.filesMultiple}
                    onFileUploadComplete={this.save}
                    uploadTarget={this.props.uploadTarget}
                    viewable={this.props.viewable}
                    params={this.props.getFileUploadParams()}
                />
            );
        case INPUT_TYPES.EMAIL:
            return <Input type="email" {...baseProps} />;
        case INPUT_TYPES.TEXTAREA:
            return <Input.TextArea autoSize={{minRows: this.props.minRows || 4}} {...baseProps} />;
        case INPUT_TYPES.TEXT:
        default:
            return <Input {...baseProps} />;
        }
    };
    render() {
        const { editing } = this.state;
        /* eslint-disable no-unused-vars */
        const {
            fieldType,
            editable,
            dataIndex,
            title,
            record,
            handleSave,
            index,
            rules,
            ...restProps
        } = this.props;
        return (
            <td
                ref={node => (this.cell = node)}
                {...restProps}
                className={cx(restProps.className, {
                    "editable-cell": editable
                })}
            >
                {editable ? (
                    <EditableContext.Consumer>
                        {form => {
                            this.form = form;
                            return editing ? (
                                <FormItem style={{ margin: 0 }}>
                                    {form.getFieldDecorator(dataIndex, {
                                        rules: [...rules],
                                        initialValue: record[dataIndex]
                                    })(this.getFieldType(fieldType))}
                                </FormItem>
                            ) : (
                                <div
                                    className="editable-cell-value-wrap"
                                    style={{ paddingRight: 24 }}
                                    onClick={this.toggleEdit}
                                >
                                    {restProps.children}
                                </div>
                            );
                        }}
                    </EditableContext.Consumer>
                ) : (
                    restProps.children
                )}
            </td>
        );
    }
}

EditableCell.defaultProps = {
    rules: []
};

EditableCell.propTypes = {
    editable: PropTypes.bool,
    dataIndex: PropTypes.string,
    fieldType: PropTypes.string,
    filesMultiple: PropTypes.bool,
    rules: PropTypes.array,
    options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    max: PropTypes.number,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    record: PropTypes.object,
    index: PropTypes.number,
    viewable: PropTypes.bool,
    handleSave: PropTypes.func,
    children: PropTypes.any,
    uploadTarget: PropTypes.string,
    getFileUploadParams: PropTypes.func
};

export { EditableCell, EditableRow };
/* eslint-enable no-unused-vars */
